import { render, staticRenderFns } from "./FacturaClientes.vue?vue&type=template&id=9ad22550"
import script from "./FacturaClientes.vue?vue&type=script&lang=js"
export * from "./FacturaClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports